<span #label class="label">

</span>
<span #content *ngIf="!isLink">
    <span #pre>

    </span>
    <span #subcontent>
        <ng-template app-placeholder> <!-- dynamic components here -->
        
        </ng-template>
    </span>
    <span #post>

    </span>
</span>
<a #content *ngIf="isLink">
    <span #pre>

    </span>
    <span #subcontent>
        <ng-template app-placeholder> <!-- dynamic components here -->
        
        </ng-template>
    </span>
    <span #post>

    </span>
</a>